import { render, staticRenderFns } from "./create.vue?vue&type=template&id=dc57246a&scoped=true&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"
import style0 from "./create.vue?vue&type=style&index=0&lang=css&"
import style1 from "./create.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./create.vue?vue&type=style&index=2&lang=css&"
import style3 from "./create.vue?vue&type=style&index=3&id=dc57246a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc57246a",
  null
  
)

export default component.exports